// The sheets any screen can open: moving money in and out, and the player's PAPER.

import { createStore, useStore } from "./store";

export type Sheet = { kind: "funds"; tab: "deposit" | "withdraw" } | { kind: "paper" } | null;

export const sheet = createStore<Sheet>(null);

export const useSheet = () => useStore(sheet);

export const openFunds = (tab: "deposit" | "withdraw" = "deposit") => sheet.set({ kind: "funds", tab });
export const openPaper = () => sheet.set({ kind: "paper" });
export const closeSheet = () => sheet.set(null);
